'use client';

import { CategoryTree } from '@/fo/api/magento';
import { MappedProduct } from '@/fo/util/map-product-data';

import { getSearchSuggestions } from '../api/getSearchSuggestions';
import { storeSearchSuggestion, selectQuery } from '../lib/store';

const search = async (query: string) => {
  storeSearchSuggestion.send({
    type: 'setQuery',
    query
  });

  storeSearchSuggestion.send({
    type: 'setLoading',
    isLoading: true
  });

  const suggestions = await getSearchSuggestions(query);
  // Вместо AbortController
  const currentQuery = selectQuery(storeSearchSuggestion.getSnapshot());
  if (currentQuery !== query) {
    return;
  }

  if (!('error' in suggestions)) {
    storeSearchSuggestion.send({
      type: 'set',
      state: suggestions
    });
  }

  storeSearchSuggestion.send({
    type: 'setLoading',
    isLoading: false
  });
};

export const setDefaultData = (data: {
  products: MappedProduct[];
  categories: CategoryTree[];
}) => {
  const { products, categories } = data;

  storeSearchSuggestion.send({
    type: 'set',
    state: {
      defaultProducts: products,
      defaultCategories: categories
    }
  });
};

export const fillDefaultData = () => {
  const defaultProducts =
    storeSearchSuggestion.getSnapshot().context.defaultProducts;
  const defaultCategories =
    storeSearchSuggestion.getSnapshot().context.defaultCategories;

  storeSearchSuggestion.send({
    type: 'set',
    state: {
      products: defaultProducts,
      categories: defaultCategories,
      query: ''
    }
  });
};

export const searchActions = {
  search,
  setDefaultData,
  fillDefaultData
};
